// extracted by mini-css-extract-plugin
module.exports =  {"info":"da51a739f7--info--ymSCm","info__group":"da51a739f7--info__group--Y082m"};